<div class="card-item-vertical" [class.card-item-vertical-completed]="card.completed">
  <div class="card-item-vertical-progress">
    <div *ngIf="showProgressLine" class="card-item-vertical-line"></div>

    <div class="card-item-vertical-dot" [class.card-item-vertical-dot-completed]="card.completed">
      <mat-icon *ngIf="card.completed">check</mat-icon>
      <span *ngIf="!card.completed">{{ cardIndex + 1 }}</span>
    </div>
  </div>

  <div
    class="card-item-vertical-content"
    (click)="cardClick.emit(this.card)"
    (keydown.enter)="cardClick.emit(this.card)"
    tabindex="0"
    role="button"
    [attr.aria-label]="'Open ' + card.header"
  >
    <div class="card-item-vertical-inner">
      <div class="card-item-vertical-image">
        <div *ngIf="card.image" class="card-item-vertical-image-content">
          <img [src]="card.image" [alt]="card.header" />
        </div>
        <div *ngIf="!card.image" class="card-item-vertical-image-placeholder">
          <mat-icon>
            {{
              cardType === 'course'
                ? 'play_circle_outline'
                : cardType === 'event'
                  ? 'event'
                  : cardType === 'playlist'
                    ? 'playlist_play'
                    : 'description'
            }}
          </mat-icon>
        </div>

        <div *ngIf="card.completed" class="card-item-vertical-completion-indicator">
          <mat-icon>check_circle</mat-icon>
        </div>

        <div *ngIf="card.type" class="card-item-vertical-type-badge">
          {{ card.type }}
        </div>
      </div>

      <div class="card-item-vertical-details">
        <h3 class="card-item-vertical-title">{{ card.header }}</h3>

        <p *ngIf="card.subHeader" class="card-item-vertical-subtitle">{{ card.subHeader }}</p>
      </div>
    </div>
  </div>
</div>
